import { GalleryFileServiceProxy, GalleryServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { downloadGET } from '@/api/api'
import { readAsDataURL } from '@/utils'
import { message, Modal } from 'ant-design-vue'
import i18n from '@/locales'

const gsp = new GalleryServiceProxy()
const gfsp = new GalleryFileServiceProxy()

const GALLERY_API = {
  create: gsp.save.bind(gsp) as typeof gsp.save,
  read: gsp.listAll.bind(gsp) as typeof gsp.listAll,
  delete: gsp.remove.bind(gsp) as typeof gsp.remove,
  rename: gsp.update.bind(gsp) as typeof gsp.update,
}

const IMAGE_API = {
  read: gfsp.page.bind(gfsp) as typeof gfsp.page,
  delete: gfsp.remove.bind(gfsp) as typeof gfsp.remove,
  upload: gfsp.upload.bind(gfsp) as typeof gfsp.upload,
  move: gfsp.changeGallery.bind(gfsp) as typeof gfsp.changeGallery,
  rename: gfsp.rename.bind(gfsp) as typeof gfsp.rename,
}

const GALLERY_SCHEMA = {
  create: [
    {
      label: 'page_console_gallery_name' || '图库名',
      prop: 'galleryName',
      rules: [{ required: true, message: 'page_dform_must' }],
      ui: {},
    },
  ],
  rename: [
    {
      label: 'page_console_gallery_name' || '图库名',
      prop: 'galleryName',
      rules: [{ required: true, message: 'page_dform_must' }],
      ui: { widget: 'input' },
    },
    { prop: 'id', ui: { hidden: true } },
  ],
}

const IMAGE_SCHEMA = {
  upload: [
    {
      label: 'page_console_gallery_pic' || '图片',
      prop: 'file',
      rules: [{ required: true, message: 'page_dform_must' }],
      ui: { widget: 'image-upload', initialValue: [] },
    },
    { prop: 'galleryId', ui: { hidden: true } },
  ],
  move: [
    {
      label: 'page_console_gallery_target' || '目标图库',
      prop: 'galleryId',
      rules: [{ required: true, message: 'page_dform_must' }],
      ui: { widget: 'select' },
    },
    { prop: 'ids', ui: { hidden: true } },
  ],
}

function confirmDelete(fn, ...args) {
  return new Promise(resolve => {
    Modal.confirm({
      title: i18n.t('delete_tips'),
      okText: i18n.t('yes') as string,
      okType: 'danger',
      cancelText: i18n.t('no') as string,
      onOk() {
        fn(...args)
          .then(() => {
            success()
            resolve(true)
          })
          .catch(() => {
            resolve(false)
          })
      },
    })
  })
}

function fileToUrl(files, map) {
  for (let file of files) {
    const key = file.fileName + file.objectKey
    if (map.has(key)) {
      file.url = map.get(key)
      if (!file.url) file.error = true
    } else {
      file.loading = true
      downloadGET(file.fileName, file.objectKey, file.contentType)
        .then(blob => readAsDataURL(blob))
        .then(url => {
          file.url = url
          map.set(key, url)
        })
        .catch(() => {
          file.error = true
          map.set(key, '')
        })
        .finally(() => {
          file.loading = false
        })
    }
  }
}

function success() {
  message.success(i18n.t('page_console_gallery_success' || '操作成功'))
}

function error() {
  message.error(i18n.t('page_console_gallery_fail' || '操作失败'))
}

export { GALLERY_API, IMAGE_API, GALLERY_SCHEMA, IMAGE_SCHEMA, confirmDelete, fileToUrl, success, error }
